/**
 * Decorates the AngularJS error handler in order to also push the error to the app error handler.
 * @param {ngExceptionHandler} $delegate The original service that handles exceptions, to forward
 *                                       the exceptions after logging them on the app error
 *                                       handler.
 * @param {ngInjector}         $injector To access the app error handler service.
 * @return {Function}
 * @ngesdoc decorator
 * @ngservice $exceptionHandler
 * @ngmodule common
 */
const exceptionHandlerDecorator = ($delegate, $injector) => {
  'ngInject';

  return (exception, cause) => {
    $injector.get('appErrorHandler').handle(exception, '', true);
    $delegate(exception, cause);
  };
};

export default exceptionHandlerDecorator;
